/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import {Meta, Title} from "@angular/platform-browser";
import 'angular2-highcharts';
import {Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../../services/company.service";
import {AppDataService} from "../../../../services/app-data.service";

declare let QRCode: any;
declare let FB: any;
declare let Swal: any;
declare var $ : any;
declare var require: any;
declare var google: any;

@Component({
  selector : 'checklist-screen',
  templateUrl:'checklist.component.html'
})
export class CheckListComponent implements OnInit {

  public checkList;
  public idx;
  public uid;
  public chk;
  public name;
  public max;
  public reload(){
    this.uid = this._appData.instagramUser.uid;
    let user=this._appData.instagramUser;
    this.chk=this._appData.param.group
    this.idx=this._appData.param.id


    this._companyService.getUserWrit(user,this.chk).get().then(val=>{
      let wrt=val.data();
      if (wrt){//i have a writ to solve with this question
        let job=wrt.jobs[this.idx];
        this.max=job.maxCheck;
        this.name=job.description
        if (job){
          this.checkList=job.check         
        }
      }

    })

  }
  public ngOnInit(): any {
    


  }
    constructor( public _sanitizer: DomSanitizer,private title: Title, private fb : FormBuilder,public _router : Router,private meta : Meta,private _routeParams : ActivatedRoute,private _companyService : CompanyService, public _appData : AppDataService) {
    }
    public checkItem(i,chk){
      this.checkList[i].check=chk;
      if (this.max){
        let count=0;
        this.checkList.forEach(v=>{
          if (v.check){
            count++;
          }
        })
        if (count>this.max){
          Swal.fire({title:'Você atingiu o máximo de checks possível. Remova alguma opção para poder selecionar essa.'})
          this.checkList[i].check=false;
          let checkL=this.checkList;
          this.checkList=null;
          setTimeout(v=>{
            this.checkList=checkL
          },1000)
          return;
  
        }
      }

      this._companyService.getUserWrit(this._appData.instagramUser,this.chk).get().then(val=>{
        let wrt=val.data();
        wrt.jobs[this.idx].check=this.checkList;
        if (!wrt.jobs[this.idx].dateStart){
          let date=new Date();
          wrt.jobs[this.idx].dateStart=date.getTime();
        }
        this._companyService.getUserWrit(this._appData.instagramUser,this.chk).set(wrt)

  
      })
    }
  // within a window load,dom ready or something like that place your:
    private _initializeAppData() : void {

     }
 

 
    
}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/+checklist/checklist.component.ts